import { createStore } from "vuex";

import {
  addCircleOutline,
  addCircleSharp,
  addOutline,
  addSharp,
  arrowBackOutline,
  arrowBackSharp,
  briefcaseOutline,
  briefcaseSharp,
  clipboardOutline,
  clipboardSharp,
  closeOutline,
  closeSharp,
  documentTextOutline,
  documentTextSharp,
  easelOutline,
  easelSharp,
  informationCircleOutline,
  informationCircleSharp,
  mailOutline,
  mailSharp,
  peopleOutline,
  peopleSharp,
  ribbonOutline,
  ribbonSharp,
  schoolOutline,
  schoolSharp,
  settingsOutline,
  settingsSharp,
  logOutOutline,
  logOutSharp,
  arrowForwardOutline,
  arrowForwardSharp,
  fileTrayFullOutline,
  calendarOutline,
  calendarSharp,
  linkOutline,
  linkSharp,
  fileTrayFullSharp,
  checkmarkOutline,
  checkmarkSharp,
  pencilOutline,
  pencilSharp,
  eyeOutline,
  eyeSharp,
  earthOutline,
  earthSharp,
  flaskOutline,
  flaskSharp,
  medkitOutline,
  medkitSharp,
  medalOutline,
  medalSharp,
  logoGoogle,
  downloadOutline,
  downloadSharp,
  personOutline,
  personSharp,
  eyeOffOutline,
  eyeOffSharp,
} from "ionicons/icons";
import { User, UserProps } from "./types";

const grades_scale = {
  min: 4,
  max: 10,
  only_integer: true,
  input_regex: /^([0-9]|10)([.,][0-9]{0,2})?$/g,
};

export const store = createStore({
  mutations: {
    editUser(state: any, user: UserProps | undefined) {
      state.user = user;
    },
    setLoggedUser(state: any, logged: boolean) {
      state.logged_user = logged;
    },
  },
  actions: {
    login({ commit }, user) {
      commit("editUser", user);
    },
    logout({ commit }) {
      commit("editUser", undefined);
    },
    signalLogin({ commit }) {
      commit("setLoggedUser", true);
    },
    signalLogout({ commit }) {
      commit("setLoggedUser", false);
    },
  },
  state() {
    return {
      menu: {
        items: {
          learning_sessions: {
            url_names: {
              student: ["learning_sessions", "learning_session"],
            },
            icon_ref: "easel",
          },
          curriculum: {
            url_names: {
              student: ["curriculum"],
            },
            icon_ref: "school",
          },
          openbadges: {
            url_names: {
              student: ["openbadges"],
              admin: ["openbadges"],
            },
            icon_ref: "ribbon",
          },
          citizenship_report: {
            url_names: {
              student: ["citizenship_report"],
              admin: ["citizenship_report"],
            },
            icon_ref: "clipboard",
          },
          announcements: {
            url_names: {
              student: ["announcements", "announcement"],
            },
            icon_ref: "mail",
          },
          project_courses: {
            url_names: {
              teacher: [
                "project_courses",
                "project_course",
                "announcement",
                "student",
              ],
              admin: [
                "project_courses_hub",
                "project_course",
                "announcement",
                "student",
              ],
            },
            icon_ref: "brief_case",
          },
          ordinary_classes: {
            url_names: {
              teacher: ["ordinary_classes", "ordinary_class", "student"],
              admin: [
                "ordinary_classes",
                "ordinary_class",
                "student",
                "manage_ordinary_classes",
              ],
            },
            icon_ref: "people",
          },
          course_proposal: {
            url_names: {
              teacher: ["course_proposal", "propositions_history"],
            },
            icon_ref: "add_circle",
          },
          course_proposals: {
            url_names: {
              admin: ["propositions_history", "course_proposal"],
            },
            icon_ref: "archive",
          },
          learning_sessions_management: {
            url_names: {
              admin: ["learning_sessions_management"], // TODO (8*): non è detto che userò questa pagina, dato che non c'è una seconda lista
            },
            icon_ref: "calendar",
          },
          constraints_management: {
            url_names: {
              admin: ["constraints_management"],
            },
            icon_ref: "link",
          },
          open_day_courses: {
            url_names: {
              teacher: ["open_day_courses"],
            },
            icon_ref: "easel",
            additional_controls: {
              teacher: () => User.getLoggedUser()?.subtype == "tutor",
            },
          },
          settings: {
            // TODO (4): Fare pagina settings e profilo
            url_names: {
              student: ["settings"],
              teacher: ["settings"],
              admin: ["settings"],
            },
            icon_ref: "settings",
          },
          profile: {
            url_names: {
              student: ["profile"],
              teacher: ["profile"],
              admin: ["profile"],
            },
            icon_ref: "person",
          },
          logout: {
            // TODO (5): spostare in profilo quando verrà creato
            url_names: {
              student: ["logout"],
              teacher: ["logout"],
              admin: ["logout"],
            },
            icon_ref: "logout",
          },
          info: {
            url_names: {
              student: ["info"],
              teacher: ["info"],
              admin: ["info"],
            },
            icon_ref: "information_circle",
          },
        },
        order: {
          student: [
            "learning_sessions",
            "announcements",
            "curriculum",
            /*"openbadges",
            "citizenship_report",
            "settings",*/
            "profile",
            //"info",
          ],
          teacher: [
            "project_courses",
            "course_proposal",
            "open_day_courses",
            "ordinary_classes",
            //"settings",
            "profile",
            //"info",
          ],
          admin: [
            // TODO (4): fare funzionalità admin
            "project_courses",
            "ordinary_classes",
            "course_proposals",
            "learning_sessions_management",
            /*"constraints_management",
            "citizenship_report",
            "openbadges",
            "settings",*/
            "profile",
            //"info",
          ],
        },
        default_item: {
          student: "learning_sessions",
          teacher: "project_courses",
          admin: "project_courses_hub",
        },
        index: 0,
      },
      icons: {
        easel: {
          ios: easelOutline,
          md: easelSharp,
        },
        school: {
          ios: schoolOutline,
          md: schoolSharp,
        },
        ribbon: {
          ios: ribbonOutline,
          md: ribbonSharp,
        },
        clipboard: {
          ios: clipboardOutline,
          md: clipboardSharp,
        },
        settings: {
          ios: settingsOutline,
          md: settingsSharp,
        },
        information_circle: {
          ios: informationCircleOutline,
          md: informationCircleSharp,
        },
        brief_case: {
          ios: briefcaseOutline,
          md: briefcaseSharp,
        },
        add_circle: {
          ios: addCircleOutline,
          md: addCircleSharp,
        },
        arrow_back: {
          ios: arrowBackOutline,
          md: arrowBackSharp,
        },
        arrow_forward: {
          ios: arrowForwardOutline,
          md: arrowForwardSharp,
        },
        add: {
          ios: addOutline,
          md: addSharp,
        },
        close: {
          ios: closeOutline,
          md: closeSharp,
        },
        document_text: {
          ios: documentTextOutline,
          md: documentTextSharp,
        },
        mail: {
          ios: mailOutline,
          md: mailSharp,
        },
        person: {
          ios: personOutline,
          md: personSharp,
        },
        people: {
          ios: peopleOutline,
          md: peopleSharp,
        },
        logout: {
          ios: logOutOutline,
          md: logOutSharp,
        },
        archive: {
          ios: fileTrayFullOutline,
          md: fileTrayFullSharp,
        },
        calendar: {
          ios: calendarOutline,
          md: calendarSharp,
        },
        link: {
          ios: linkOutline,
          md: linkSharp,
        },
        checkmark: {
          ios: checkmarkOutline,
          md: checkmarkSharp,
        },
        pencil: {
          ios: pencilOutline,
          md: pencilSharp,
        },
        eye: {
          ios: eyeOutline,
          md: eyeSharp,
        },
        eyeOff: {
          ios: eyeOffOutline,
          md: eyeOffSharp,
        },
        earth: {
          ios: earthOutline,
          md: earthSharp,
        },
        flask: {
          ios: flaskOutline,
          md: flaskSharp,
        },
        medkit: {
          ios: medkitOutline,
          md: medkitSharp,
        },
        medal: {
          ios: medalOutline,
          md: medalSharp,
        },
        google: {
          ios: logoGoogle,
          md: logoGoogle,
        },
        download: {
          ios: downloadOutline,
          md: downloadSharp,
        },
      },
      languages: ["italian", "english"],
      language: "italian",
      elements: {
        italian: {
          credits_constraints: "Vincoli crediti",
          session: "Sessione",
          current: "Corrente",
          future: "Future",
          upcoming: "Imminente",
          completed: "Completate",
          no_sessions: "Nessuna sessione di apprendimento",
          course: "Corso",
          courses: "Corsi",
          learning_area: "Area di apprendimento",
          no_proposed_courses: "Nessun corso proposto",
          credits: "Crediti",
          pending: "In attesa",
          enrolled: "Iscritto",
          not_enrolled: "Non iscritto",
          select: "Seleziona",
          open_enrollment: "Iscrizioni aperte",
          planned: "Pianificate",
          error: "Errore",
          maximum_credits_error:
            "Il corso supera il limite dei crediti massimi",
          ok: "Ok",
          school_year: "Anno scolastico",
          school_year_choice: "Scegli un anno scolastico",
          section: "Sezione",
          sections: "Sezioni",
          grades: "Valutazioni",
          final_grade: "Valutazione finale",
          description: "Descrizione",
          context_description: "Descrizione del contesto",
          date: "Data",
          evaluation: "Valutazione",
          intermediate_arithmetic_mean: "Media aritmetica intermedia",
          final: "Finale",
          no_grades: "Nessun voto registrato",
          expected_learning_results: "Risultati di apprendimento attesi",
          criterions: "Criteri",
          activities: "Attività",
          growth_area: "Area di crescita personale",
          growth_areas: "Aree di crescita personale",
          creation_school_year: "Anno scolastico di creazione",
          hour: "Ora",
          hours: "Ore",
          up_hours: "Ore UP",
          students_number: "Numero di studenti",
          proposer_teacher: "Insegnante proponente",
          certifying_admin: "Amministratore certificante",
          course_information_not_found: "Informazioni del corso non trovate",
          learning_session: "Sessione di apprendimento",
          learning_sessions: "Sessioni di apprendimento",
          teacher_learning_session_selection_message:
            "Seleziona una sessione di apprendimento per vedere i corsi in cui insegni o che ha un tuo insegnameto associato",
          student_learning_session_selection_message:
            "Seleziona una sessione di apprendimento per vedere i corsi a cui sei iscritto",
          teacher: "Insegnante",
          associated: "Associati",
          my_associated_teachings: "Miei insegnamenti associati",
          no_project_classes: "Nessuna classe progetto",
          section_choice: "Scegli una sezione",
          no_sections: "Nessuna sezione disponibile",
          student: "Studente",
          class: "Classe",
          grade_insertion: "Inserimento valutazione",
          insert_grade: "Inserisci valutazione",
          grade: "Valutazione",
          empty_descriptions: "Descrizione vuota",
          grade_value_error:
            "Inserire un voto che sia un numero " +
            (grades_scale.only_integer ? "intero" : "") +
            " compreso tra " +
            grades_scale.min +
            " e " +
            grades_scale.max,
          learning_context: "Contesto di apprendimento",
          learning_context_choice: "Scegli un contesto di apprendimento",
          no_messages: "Nessun messaggio",
          publishment: "Pubblicazione",
          title: "Titolo",
          message: "Messaggio",
          publish: "Pubblica",
          announcement_publishment: "Pubblicazione annuncio",
          to: "A",
          empty_titles_or_messages: "Titoli e/o messagi vuoti",
          no_selected_sections: "Nessuna sezione selezionata",
          message_not_sent_sections: "Messaggio non inviato alle sezioni",
          no_courses: "Nessun corso disponibile",
          group: "Gruppo",
          maximum_courses_error: "Corsi per gruppo massimi raggiunti",
          classes: "Classi",
          no_classes: "Nessuna classe disponibile",
          students: "Studenti",
          no_students: "Nessuno studente disponibile",
          school_years_selection_message:
            "Seleziona un anno scolastico per vedere le classi associate",
          cf: "Codice fiscale",
          name: "Nome",
          surname: "Cognome",
          gender: "Genere",
          birth_date: "Data di nascita",
          address: "Indirizzo",
          email: "E-mail",
          male: "Maschio",
          female: "Femmina",
          other: "Altro",
          progression: "Progressi",
          context_credits: "Crediti nel contesto",
          area_credits: "Crediti per area",
          auth: "Autenticazione",
          username: "Username",
          password: "Password",
          new_password: "Nuova password",
          admin: "Amministratore",
          login: "Login",
          wrong_username_or_password: "Username o password sbagliati",
          server_error: "Errore del server",
          no_username: "Username non inserito",
          no_password: "Password non inserita",
          reference_model: "Modello di riferimento",
          possible_models: "Possibili modelli",
          characteristics: "Caratteristiche",
          conduct: "Svolgimento",
          teaching_list: "Insegnamenti",
          access_object: "Accesso",
          teachers: "Insegnanti",
          italian: "Italiano",
          english: "Inglese",
          propose: "Proponi",
          min_students: "Studenti minimi",
          max_students: "Studenti massimi",
          area_choice: "Scegli un'area di apprendimento",
          growth_choice: "Scegli un'area di crescita personale",
          learning_sessions_choice: "Scegli una sessione di apprendimento",
          learning_session_needed: "Sessione di apprendimento necessario",
          group_choice: "Scegli un gruppo",
          grant_access: "Concedi l'accesso",
          add_teacher: "Aggiungi insegnante",
          teaching_choices: "Scegli un insegnamento",
          growth_area_choices: "Scegli un'area di crescita personale",
          study_year: "Anno di studio",
          study_address: "Indirizzo di studio",
          study_year_choice: "Scegli un anno di studio",
          study_address_choice: "Scegli un indirizzo di studio",
          gender_choice: "Scegli un genere",
          presidium: "Presidio",
          main_study_year: "Anno di studi principale",
          students_per_section: "Studenti per sezione",
          students_distribution: "Distribuzione studenti",
          num_section: "Numero di sezioni (1: A, 2: A e B, ...)",
          teaching: "Insegnamento",
          add: "Aggiungi",
          study_address_needed: "Indirizzo di studio necessario",
          teachings: "Insegnamenti",
          no_teachings: "Nessun insegnamento",
          no_growth_areas: "Nessuna area di crescita personale",
          learning_context_needed: "Indirizzo di studio necessario",
          no_access_proposition:
            "Nessuna proposta di accesso per le classi ordinarie",
          teacher_choice: "Scegli un insegnante",
          main_teacher: "Coordinatore di classe",
          num_section_needed: "Numero delle sezioni necessario",
          no_teacher_proposition: "Nessuna insegnante proposto",
          school_years: "Anni scolastici",
          no_school_years: "Nessun anno scolastico",
          confirmation_date: "Data di conferma",
          course_confirmation_date: "Data conferma modello di corso",
          edit: "Modifica",
          no_elements: "Nessun elemento",
          curriculum: "Curriculum",
          openbadges: "OpenBadge",
          citizenship_report: "Cittadinanza attiva",
          announcements: "Annunci",
          settings: "Impostazioni",
          logout: "Logout",
          project_courses: "Corsi progetto",
          ordinary_classes: "Classi ordinarie",
          course_proposal: "Proposta corso",
          course_proposals: "Proposte di corsi",
          learning_sessions_management: "Gestione sessioni di apprendimento",
          constraints_management: "Gestione vincoli",
          info: "Info",
          specific_information: "Informazioni specifiche",
          non_existing_session: "Sessione non esistente",
          min: "Min",
          max: "Max",
          course_for_noone: "Corso aperto a nessuna classe",
          open_to: "Aperto a",
          no_teachers: "Nessun insegnante",
          or: "Oppure",
          login_with_account: "Accedi con il tuo account",
          google: "Google",
          course_confirmation: "Confermi di iscriverti al corso?",
          course_pending:
            "Purtroppo il corso è già pieno. Vuoi segnalare che ti sarebbe piaciuto partecipare?",
          course_warning: "Attenzione: non sarà possibile disiscriversi",
          no: "No",
          yes: "Sì",
          open_day: "Orientation day",
          user_not_valid: "Utente non valido",
          user_not_found: "Utente non trovato",
          proposition_confrimation: "Confermi di voler proporre il corso?",
          general_error: "Si è verificato un errore",
          missing_italian_title: "Titolo in italiano mancante",
          missing_italian_description: "Descrizione in italiano mancante",
          up_hours_error:
            "Devi inserire un numero di ore UP maggiore o uguale a 0",
          credits_error: "Devi inserire un numero di crediti maggiore a 0",
          missing_italian_expected_learning_results:
            "Risultati di apprendimento attesi in italiano mancanti",
          missing_italian_criterions: "Criteri in italiano mancanti",
          missing_italian_activities: "Attività in italiano mancanti",
          missing_area_id: "Seleziona un'area di apprendimento",
          missing_growth_areas:
            "Aggiungi almeno un'area di apprendimento personale",
          students_error: "Il numero di studenti deve essere maggiore di 0",
          min_max_error:
            "Il numero massimo di studenti deve essere maggiore di 4 rispetto al numero minimo",
          max_greater_min_error:
            "Il numero massimo di studenti deve essere maggiore rispetto al numero minimo",
          missing_session_id: "Seleziona una sessione di apprendimento",
          missing_access:
            "Devi dare l'accesso a questo corso almeno ad una classe",
          teaching_error:
            "Devi aggiungere almeno un insegnamento e non più di tre",
          missing_class_group: "Seleziona un gruppo",
          num_sections_error:
            "Devi aggiungere un numero di sezioni maggiore a 0",
          missing_teachers: "Aggiungi almeno un insegnante",
          successful_proposal: "Corso proposto con successo",
          duplicate_course: "Corso duplicato" /* corso o classe duplicata */,
          successful_operation: "Operazione eseguita con successo",
          no_final_grade: "No voto finale",
          approval_confirmation: "Confermi di voler approvare il corso?",
          rejection_confirmation: "Confermi di voler rifiutare il corso?",
          successful_confirmation: "Corso confermato con successo",
          successful_rejection: "Corso rifiutato",
          project_class_confirmation: "Conferma classe progetto",
          approve_project_class_too: "Approva anche la classe progetto",
          changes_not_made: "Attenzione! Modifiche non apportate",
          approve: "Approva",
          reject: "Rifiuta",
          view: "Visualizzazione",
          approved: "Approvato",
          to_approve: "Da approvare",
          project_classes_propositions: "Proposte di classi progetto",
          courses_propositions_per_year: "Proposte di corsi nell'anno",
          propositions: "Proposte",
          no_propositions: "Nessuna proposta",
          no_types_propositions: "Nessun tipo di proposta",
          propositions_type_choice: "Scegli il tipo di proposte",
          project_classes_propositions_selection_message:
            "Seleziona una sessione di apprendimento per vedere delle proposte delle classi progetto",
          courses_propositions_selection_message:
            "Seleziona una sessione di apprendimento per vedere delle proposte di corsi (senza una classe progetto) dell'anno associato",
          not_confirmed: "Non confermata",
          project_class: "Classe progetto",
          fully_booked: "Non più disponibile",
          wrong_subscription: "Iscrizione non andata a buon fine",
          confirm: "Conferma",
          project_class_confirmation_question:
            "Confermi di voler confermare questa classe?",
          project_class_successful_confirmation:
            "Classe progetto confermata con successo",
          students_number_error:
            "Il numero di studenti non rispetta i limiti rispettati dal corso", // TODO (4): mettere lista parametri a getCurrentElement
          final_confirmation: "Conferma finale classe progetto",
          project_class_status: "Stato classe progetto",
          project_class_confirmation_date:
            "Data di conferma della classe progetto",
          learning_session_not_upcoming:
            "Sessione di apprendimento non imminente",
          project_class_already_confirmed: "Classe progetto già confermata",
          clear: "Reset",
          remove_grade_confirmation: "Sicuro di voler rimuovere questo voto?",
          no_grade_remotion_permissions:
            "Non hai i permessi per rimuovere questo voto",
          cannot_remove_grade: "Non puoi rimuovere questo voto",
          successful_grade_remotion: "Voto rimosso con successo",
          cancel: "Annulla",
          edit_grade_confirmation: "Sicuro di voler modificare questo voto?",
          with_following_edits: "Con le seguenti modifiche?",
          italian_description: "Descrizione in italiano",
          english_description: "Descrizione in inglese",
          no_grade_edit_permissions:
            "Non hai i permessi per modificare questo voto",
          successful_edit: "Voto modificato con successo",
          no_future_date: "Non puoi utilizzare una data futura",
          grade_edit: "Modifica voto",
          no_edits: "Non sono presenti modifiche",
          additional_preferences: "Preferenze aggiuntive",
          remove: "Rimuovi",
          remove_student_confirmation:
            "Sicuro di voler rimuovere questo studente da questa classe progetto?",
          class_already_confirmed:
            "Classe progetto già confermata definitivamente",
          successful_student_remotion:
            "Studente rimosso con successo da questa classe progetto",
          move: "Sposta",
          project_class_movement_choice:
            "Scegli la classe progetto dove spostare questo studente",
          actual_course: "Corso attuale",
          move_student_confirmation:
            "Sicuro di voler spostare questo studente?",
          cannot_move_for_credits:
            "Questo studente non può essere spostato in questo corso perchè non possiede crediti liberi sufficienti",
          cannot_move_for_group:
            "Questo studente non può essere spostato in questo corso perchè frequenta già un corso nello stesso gruppo",
          groups_courses: "Corsi per gruppo",
          constraints: "Vincoli",
          student_moved: "Studente spostato con successo",
          export: "Esporta",
          non_confirmed_export:
            "Esporta le proposte della prossima sessione non confermate",
          propositions_exported: "Proposte corsi esportate con successo",
          no_years: "Nessun anno disponibile",
          compliant_students: "Studenti conformi",
          all_compliant_students: "Tutti gli studenti conformi",
          non_compliant_students:
            "Studenti non conformi alla sessione selezionata",
          no_compliant_students: "Nessuno studente è conforme",
          orientation_credits: "Crediti di orientamento",
          clil_credits: "Crediti CLIL",
          subscribe_to: "Iscrivi",
          all_project_classes_confirmed:
            "Tutti le classi progetto sono state confermate",
          student_subscribed: "Studente iscritto con successo",
          student_subscribed_and_compliant:
            "Studente iscritto con successo e ora conforme ai vincoli della sessione",
          pending_student: "Classe progetto piena. Studente messo in attesa",
          unauthorized_operation: "Operazione non autorizzata",
          next_session_subscription: "Iscrizioni prossima sessione",
          subscriptions_exported: "Iscrizioni esportate con successo",
          open_day_courses: "Corsi orientation day",
          no_learning_contexts: "Nessun contesto di apprendimento",
          courses_selection_message:
            "Seleziona una sessione di apprendimento per vedere i corsi disponibili",
          learning_contexts: "Contesti di apprendimento",
          consultable_courses: "corsi consultabili",
          student_already_subscribed:
            "Studente già iscritto a questo corso in questa sessione",
          student_course_already_attended:
            "Corso già frequentato dallo studente in una sessione precedente",
          no_learning_areas: "Nessuna area di apprendimento",
          no_subscriptions: "Nessuna iscrizione disponibile",
          register_grades_series: "Registra serie di valutazioni",
          grade_series_insertion: "Inserimento serie di valutazioni",
          no_grades_to_insert: "Nessun voto da inserire",
          warning: "Attenzione",
          final_grades_hide:
            "Alcuni studenti a cui è stato segnato un voto ne possiedono già uno finale. Per questo quei voti verranno temporaneamente nascosti",
          grades_with_errors:
            "Alcuni voti non sono stati inseriti correttamente",
          already_existing_grades:
            "Alcuni voti sono già stati inseriti in questa data",
          learning_session_error: "Problemi con la sessione di apprendimento",
          last_session_error:
            "L'attuale sessione di apprendimento è l'ultima dell'anno scolastico",
          all_courses_confirmed:
            "Tutti i corsi sono stati approvati e associati ad una classe",
          no_file_exported: "Nessun file esportato",
          course_images: "Immagini del corso",
          max_images_error: "Il numero massimo di foto caricabili è 4",
          release_images: "Rilascia le immagini qui",
          click_to_upload: "Clicca qui per caricare",
          image_already_present: "Immagine già presente",
          images_already_present: "Una o più immagini sono già presenti",
          image_visualization_order: "Ordine di visualizzazione delle immagini",
          unauthorized_image_uploading:
            "Non sei autorizzato a caricare immagini",
          images_upload_error: "Non è stato possibile caricare le immagini",
          images_delete_error: "Non è stato possibile eliminare le immagini",
          no_uploaded_images: "Nessun'imagine caricata",
          project_class_code: "Codice classe progetto",
          project_class_code_error:
            "Codice classe progetto non valido. Deve essere lungo 8 caratteri",
          new_announcement: "Nuovo annuncio",
          announcement_error: "Errore durante la pubblicazione dell'annuncio",
          history: "Storico",
          course_details: "Dettagli corso",
          pending_students: "Studenti in attesa",
          min_students_error:
            "Il numero minimo di studenti non viene rispettato",
          max_students_error:
            "Il numero massimo di studenti non viene rispettato",
          add_ordinary_classes: "Aggiungi classi ordinarie",
          ordinary_classes_added: "Classi aggiunte con successo",
          class_already_added: "Classe già aggiunta",
          no_study_address_selected: "Nessun indirizzo di studio selezionato",
          no_study_year_selected: "Nessun anno di studio selezionato",
          greater_school_year_error:
            "L'anno scolastico selezionato deve essere maggiore o uguale all'anno corrente",
          no_ordinary_classes_to_add: "Nessuna classe ordinaria da aggiungere",
          existing_ordinary_classes: "Alcune classi erano già state inserite",
          wrong_ordinary_classes: "Alcune classi sono errate",
          ordinary_classes_partially_added: "Classi parzialmente aggiunte",
          all_classes_already_added: "Tutte le classi sono già state aggiunte",
          ordinary_class_not_inserted: "Classi ordinarie non inserite",
          ordinary_classes_not_valid: "Classi ordinarie non valide",
          add_teachers: "Aggiungi insegnanti",
          teacher_added: "Insegnante aggiunto con successo",
          teacher_already_added: "Insegnante già aggiunto",
          empty_name: "Nome vuoto",
          empty_surname: "Cognome vuoto",
          not_valid_email: "Email non valida",
          no_teachers_to_add: "Nessun insegnante da aggiungere",
          teachers_added: "Insegnanti aggiunti con successo",
          existing_teachers: "Alcuni insegnanti erano già stati inseriti",
          wrong_teachers: "Alcuni insegnanti sono errati",
          teachers_partially_added: "Insegnanti aggiunti parzialmente",
          teachers_not_inserted: "Insegnanti non inseriti",
          teachers_not_assigned: "Insegnante non assegnato",
          all_teachers_already_added:
            "Tutti gli insegnanti sono già stati aggiunti",
          all_teachers_already_assigned:
            "Tutti gli insegnanti sono già stati assegnati",
          teachers_not_valid: "Insegnanti non validi",
          add_students: "Aggiungi studenti",
          students_added: "Studenti aggiunti con successo",
          student_already_added: "Studente già aggiunto",
          no_students_to_add: "Nessuno studente da aggiungere",
          existing_students: "Alcuni studenti erano già stati inseriti",
          wrong_students: "Alcuni studenti sono errati",
          students_partially_added: "Studenti aggiunti parzialmente",
          students_not_inserted: "Studenti non inseriti",
          students_not_assigned: "Studenti non assegnati",
          all_students_already_added:
            "Tutti gli studenti sono già stati aggiunti",
          all_students_already_assigned:
            "Tutti gli studenti sono già stati assegnati",
          students_not_valid: "Studenti non validi",
          study_year_address_not_found:
            "Anno e/o indirizzo di studio non trovati",
          coordinator: "Coordinatore",
          teaching_already_added: "Insegnamento già aggiunto",
          student_choice: "Scegli uno studente",
          select_teacher: "Scegli un insegnante",
          start_date: "Data di inizio",
          end_date: "Data di fine",
          to_confirm: "Da confermare",
          new_school_year: "Nuovo anno scolastico",
          groups: "Gruppi",
          no_learning_sessions: "Nessuna sessione di apprendimento",
          add_session: "Aggiungi sessione",
          set_valid_school_year: "Imposta un anno scolastico valido",
          cancel_edits_confirm:
            "Sicuro di voler annullare le modifiche? Perderai le modifiche applicate",
          cancel_school_year_proposal_confirm:
            "Sicuro di voler annullare? L'anno scolastico proposto verrà cancellato",
          learning_sessions_proposal_confirm:
            "Confermi di voler proporre queste sessioni di apprendimento per questo nuovo anno scolastico?",
          learning_sessions_edits_confirm:
            "Confermi di voler apportare queste modifiche alle sessioni di apprendimento?",
          date_in_past_error: "Non puoi impostare una data passata",
          date_in_future_error: "Non puoi impostare una data futura",
          anticipate_learning_session_error:
            "Non puoi anticipare una sessione di apprendimento",
          open_day_too_close:
            "L'orientation day deve essere almeno 12 giorni prima dell'inizio della sessione di apprendimento",
          start_after_end:
            "La data di inizio deve essere antecedente alla data di fine",
          sessions_not_in_order:
            "Le sessioni di apprendimento non sono in ordine cronologico",
          no_changes_detected: "Nessuna modifica rilevata",
          at_least_one_group: "Deve esserci almeno un gruppo per sessione",
          learning_session_not_found: "Sessione di apprendimento non trovata",
          learning_session_not_valid: "Sessione di apprendimento non valida",
          learning_session_not_created: "Sessione di apprendimento non creata",
          learning_session_not_updated:
            "Sessione di apprendimento non aggiornata",
          learning_sessions_already_existent:
            "Sessione di apprendimento già esistente",
          learning_sessions_added: "Sessioni di apprendimento aggiunte",
          existing_learning_session:
            "Alcune sessioni di apprendimento esistono già",
          wrong_learning_session:
            "Alcune sessioni di apprendimento sono sbagliate",
          learning_sessions_partially_added:
            "Sessioni di apprendimento aggiunte parzialmente",
          overlapping_learning_session:
            "Alcune sessioni di apprendimento si sovrappongono",
          all_overlapping_learning_session:
            "Ogni sessione di apprendimento si sovrappone a un'altra",
          start: "Inizio",
          end: "Fine",
          profile: "Profilo",
          profile_image: "Immagine profilo",
          profile_edits_confirm: "Confermi le modifiche fatte al tuo profilo?",
          image_not_valid: "Immagine non valida",
          iamge_delete_error: "L'immagine non può essere cancellata",
          profile_not_edited: "Profilo non modificato",
          profile_partial_edited: "Profilo parzialmente modificato",
          successful_profile_edit: "Profilo modificato con successo",
          profile_no_edited: "Profilo non modificato",
          profile_partially_edited: "Profilo modificato parzialmente",
          empty_field_error:
            "Non è possibile cancellare il testo di un campo completamente",
        },
        english: {
          credits_constraints: "Credits constraints",
          session: "Session",
          current: "Current",
          future: "Future",
          upcoming: "Upcoming",
          completed: "Completed",
          no_sessions: "No learning sessions",
          course: "Course",
          courses: "Courses",
          learning_area: "Learning area",
          no_proposed_courses: "No proposed courses",
          credits: "Credits",
          pending: "Pending",
          enrolled: "Enrolled",
          not_enrolled: "Not enrolled",
          select: "Select",
          open_enrollment: "Open enrollment",
          planned: "Planned",
          error: "Error",
          maximum_credits_error: "The course exceeds the maximum credits limit",
          ok: "Ok",
          school_year: "School year",
          school_year_choice: "Choose a school year",
          section: "Section",
          sections: "Sections",
          grades: "Grades",
          final_grade: "Final grade",
          description: "Description",
          context_description: "Context description",
          date: "Date",
          evaluation: "Evaluation",
          intermediate_arithmetic_mean: "Intermediate arithmetic mean",
          final: "Final",
          no_grades: "No grades recorded",
          expected_learning_results: "Expected learning results",
          criterions: "Criterions",
          activities: "Activities",
          growth_area: "Personal growth area",
          growth_areas: "Personal growth areas",
          creation_school_year: "Creation school year",
          hour: "Hour",
          hours: "Hours",
          up_hours: "UP hours",
          students_number: "Students number",
          proposer_teacher: "Proposer teacher",
          certifying_admin: "Certifying admin",
          course_information_not_found: "Course information not found",
          learning_session: "Learning session",
          learning_sessions: "Learning sessions",
          teacher_learning_session_selection_message:
            "Select a learning session to see the courses you teach or that has a teaching of yours associated",
          teacher: "Teacher",
          associated: "Associated",
          my_associated_teachings: "My associated teachings",
          no_project_classes: "No project classes",
          section_choice: "Choose a section",
          no_sections: "No sections available",
          student: "Student",
          class: "Class",
          grade_insertion: "Grade insertion",
          insert_grade: "Insert grade",
          grade: "Grade",
          empty_descriptions: "Empty description",
          grade_value_error:
            "Insert " +
            (grades_scale.only_integer ? "an integer" : "a") +
            " grade between " +
            grades_scale.min +
            " and " +
            grades_scale.max,
          learning_context: "Learning context",
          learning_context_choice: "Choose a learning context",
          no_messages: "No messages",
          publishment: "Publishment",
          title: "Title",
          message: "Message",
          publish: "Publish",
          announcement_publishment: "Announcement publishment",
          to: "To",
          empty_titles_or_messages: "Empty titles and/or messages",
          no_selected_sections: "No selected sections",
          message_not_sent_sections: "Message not sent to sections",
          no_courses: "No courses available",
          group: "Group",
          maximum_courses_error: "Maximum courses per group reached",
          classes: "Classes",
          no_classes: "No classes available",
          students: "Students",
          no_students: "No students available",
          school_years_selection_message:
            "Select a school year to see the associated classes",
          cf: "Fiscal code",
          name: "Name",
          surname: "Surname",
          gender: "Gender",
          birth_date: "Birth date",
          address: "Address",
          email: "E-mail",
          male: "Maschio",
          female: "Femmina",
          other: "Altro",
          progression: "Progression",
          context_credits: "Context credits",
          area_credits: "Area credits",
          auth: "Authentication",
          username: "Username",
          password: "Password",
          new_password: "New password",
          admin: "Admin",
          login: "Login",
          wrong_username_or_password: "Wrong username or password",
          server_error: "Server error",
          no_username: "Username missing",
          no_password: "Password missing",
          reference_model: "Reference model",
          possible_models: "Possible models",
          characteristics: "Characteristics",
          conduct: "Conduct",
          teaching_list: "Teachings",
          access_object: "Access",
          teachers: "Teachers",
          italian: "Italian",
          english: "English",
          propose: "Propose",
          min_students: "Minimum students",
          max_students: "Maximum students",
          area_choice: "Choose a learning area",
          growth_choice: "Choose a personal growth area",
          learning_sessions_choice: "Choose a learning session",
          learning_session_needed: "Learning session needed",
          group_choice: "Choose a group",
          grant_access: "Grant access",
          add_teacher: "Add teacher",
          teaching_choices: "Choose a teaching",
          growth_area_choices: "Choose a personal growth area",
          study_year: "Study year",
          study_address: "Study address",
          study_year_choice: "Choose a study year",
          study_address_choice: "Choose a study address",
          gender_choice: "Choose a gender",
          presidium: "Presidium",
          main_study_year: "Main study year",
          students_per_section: "Students per section",
          students_distribution: "Students distribution",
          num_section: "Numero di sezioni (1: A, 2: A and B, ...)",
          teaching: "Insegnamento",
          add: "Add",
          study_address_needed: "Study address needed",
          teachings: "Teachings",
          no_teachings: "No teachings",
          no_growth_areas: "No personal growth areas",
          learning_context_needed: "Learning context needed",
          no_access_proposition: "No access proposition for ordinary classes",
          teacher_choice: "Teacher choice",
          main_teacher: "Main teacher",
          num_section_needed: "Number of section needed",
          no_teacher_proposition: "No teacher proposed",
          school_years: "School years",
          no_school_years: "No school years",
          confirmation_date: "Confirmation date",
          edit: "Edit",
          no_elements: "No elements",
          curriculum: "Curriculum",
          openbadges: "OpenBadges",
          citizenship_report: "Citizenship report",
          announcements: "Announcements",
          settings: "Settings",
          logout: "Logout",
          project_courses: "Project courses",
          ordinary_classes: "Ordinary classes",
          course_proposal: "Course proposal",
          course_proposals: "Course proposals",
          learning_sessions_management: "Learning sessions management",
          constraints_management: "Constraints management",
          info: "Info",
          specific_information: "Specific information",
          non_existing_session: "Not existing session",
          min: "Min",
          max: "Max",
          course_for_noone: "Course open to no class",
          open_to: "Open to",
          no_teachers: "No teachers",
          or: "Or",
          login_with_account: "Login with your account",
          google: "Google",
          course_confirmation:
            "Do you confirm your subscription to the course?",
          course_pending:
            "Unfortunately the course is already full. Do you want to report that you would have liked to participate?",
          course_waring: "Warning: this choice cannot be undo",
          no: "No",
          yes: "Yes",
          open_day: "Orientation day",
          user_not_valid: "Not valid user",
          user_not_found: "User not found",
          not_existing_user: "User not valid",
          proposition_confrimation:
            "Do you confirm your proposition of the course?",
          general_error: "An error occurred",
          missing_italian_title: "Missing italian title",
          missing_italian_description: "Missing italian description",
          up_hours_error:
            "You must insert a number of up hours greater or equal than 0",
          credits_italian_error:
            "You must insert a number of credits greater than 0",
          missing_italian_expected_learning_results:
            "Missing italian expected learning results",
          missing_criterions: "Missing italian criterions",
          missing_activities: "Missing italian activities",
          missing_area_id: "Select a learning area",
          missing_growth_areas: "Add at least one personal growth area",
          students_error: "The number of students must be greater than 0",
          min_max_error:
            "The maximum number of students must be greater than the minimum number by 4",
          max_greater_min_error:
            "The maximum number of students must be greater than the minimum number",
          missing_session_id: "Select a learning session",
          missing_access:
            "You must give the access to this course to at least one class",
          teaching_error:
            "You must add at least one teaching and no more than three",
          missing_class_group: "Select a group",
          num_sections_error:
            "You must insert a number of sections greater than 0",
          missing_teachers: "Add at least one teacher",
          successful_proposal: "Course proposed successfully",
          duplicate_course: "Course duplicate",
          successful_operation: "Operation successfully performed",
          no_final_grade: "No final grade",
          approval_confirmation: "Do you confirm your approval of the course?",
          rejection_confirmation:
            "Do you confirm your rejection of the course?",
          successful_confirmation: "Course confirmed successfully",
          successful_rejection: "Course rejected",
          project_class_confirmation: "Project class confirmation",
          approve_project_class_too: "Approve also the project class",
          changes_not_made: "Warning! Changes not made",
          approve: "Approve",
          reject: "Reject",
          view: "View",
          approved: "Approved",
          to_approve: "To approve",
          project_classes_propositions: "Project classes propositions",
          courses_propositions_per_year: "Courses propositions in the year",
          propositions: "Propositions",
          no_propositions: "No propositions",
          no_types_propositions: "No types of propositions",
          propositions_type_choice: "Choose the type of propositions",
          project_classes_propositions_selection_message:
            "Select a learning session to see the project classes propositions",
          courses_propositions_selection_message:
            "Select a learning session to see the courses propositions (without a project class) of the associated year",
          not_confirmed: "Not confirmed",
          project_class: "Project class",
          fully_booked: "Fully booked",
          wrong_subscription: "Subscription not successful",
          confirm: "Confirm",
          project_class_confirmation_question:
            "Do you confirm that you want to confirm this class?",
          project_class_successful_confirmation:
            "Project class confirmed successfully",
          students_number_error:
            "The number of students does not respect the limits respected by the course",
          final_confirmation: "Final confirmation of the project class",
          project_class_status: "Project class status",
          project_class_confirmation_date: "Project class confirmation date",
          learning_session_not_upcoming: "Learning session not upcoming",
          project_class_already_confirmed: "Project class already confirmed",
          clear: "Clear",
          remove_grade_confirmation:
            "Are you sure you want to remove this grade?",
          no_grade_remotion_permissions:
            "You don't have permissions to remove this grade",
          cannot_remove_grade: "You cannot remove this grade",
          successful_grade_remotion: "Grade successfully removed",
          cancel: "Cancel",
          edit_grade_confirmation: "Are you sure you want to edit this grade?",
          with_following_edits: "With the following edits?",
          italian_description: "Italian description",
          english_description: "English description",
          no_grade_edit_permissions:
            "You don't have permissions to edit this grade",
          successful_edit: "Grade successfully edited",
          no_future_date: "You cannot use a future date",
          grade_edit: "Grade edit",
          no_edits: "No changes are present",
          additional_preferences: "Additional preferences",
          remove: "Remove",
          remove_student_confirmation:
            "Are you sure you want to remove this student from this project class?",
          class_already_confirmed: "Project class already confirmed definitely",
          successful_student_remotion:
            "Student successfully removed from this project class",
          move: "Move",
          project_class_movement_choice:
            "Choose the project class where to move this student",
          actual_course: "Actual course",
          move_student_confirmation:
            "Are you sure you want to move this student?",
          cannot_move_for_credits:
            "This student cannot be moved to this course because he/she does not have enough free credits",
          cannot_move_for_group:
            "This student cannot be moved to this course because he/she already attends a course in the same group",
          groups_courses: "Courses per group",
          constraints: "Constraints",
          student_moved: "Student moved successfully",
          export: "Export",
          propositions_exported: "Course proposals successfully exported",
          non_confirmed_export:
            "Export the next session's unconfirmed proposals",
          no_years: "No years available",
          compliant_students: "Compliant students to the selected session",
          all_compliant_students: "All compliant students",
          non_compliant_students: "Non compliant students",
          no_compliant_students: "No compliant students",
          orientation_credits: "Orientation credits",
          clil_credits: "CLIL credits",
          subscribe_to: "Subscribe",
          all_project_classes_confirmed: "All project classes confirmed",
          student_subscribed: "Student subscribed successfully",
          student_subscribed_and_compliant:
            "Student subscribed successfully and now compliant to the selected session's constraints",
          pending_student: "Project class full. Student put in pending",
          unauthorized_operation: "Unauthorized operation",
          next_session_subscription: "Next session subscriptions",
          subscriptions_exported: "Subscriptions exported successfully",
          open_day_courses: "Orientation day courses",
          courses_choice: "Choose a course",
          no_learning_contexts: "No learning contexts",
          courses_selection_message:
            "Select a learning session to see the available courses",
          learning_contexts: "Learning contexts",
          consultable_courses: "consultable courses",
          student_already_subscribed:
            "Student already subscribed to this course in this session",
          student_course_already_attended:
            "Student already attended this course in a previous session",
          no_learning_areas: "No learning area",
          no_subscriptions: "No subscription available",
          register_grades_series: "Register grades series",
          grade_series_insertion: "Grade series insertion",
          no_grades_to_insert: "No grades to insert",
          warning: "Warning",
          final_grades_hide:
            "Some students with a typed grade already have a final grade. For this reason those grades will be temporarily hidden",
          grades_with_errors: "Some grades were not inserted correctly",
          already_existing_grades:
            "Some grades were already inserted in this date",
          learning_session_error: "Error with the learning session",
          last_session_error:
            "The current learning session is the last one of the school year",
          all_courses_confirmed:
            "All courses have been approved and associated to a class",
          no_file_exported: "No file exported",
          course_images: "Course images",
          max_images_error:
            "The maximum number of photos that can be uploaded is 4",
          release_images: "Release to drop images here",
          click_upload: "Click here to upload",
          image_already_present: "Image already present",
          images_already_present: "One or more images are already present",
          image_visualization_order: "Image visualization order",
          unauthorized_image_uploading:
            "You're not authorized to upload images",
          images_upload_error: "Images could not be uploaded",
          images_delete_error: "Images could not be deleted",
          no_uploaded_images: "No uploaded images",
          project_class_code: "Project class code",
          project_class_code_error:
            "Invalid project class code. Must be 8 characters long",
          new_announcement: "New announcement",
          announcement_error: "Error during announcement publishment",
          history: "History",
          course_details: "Course details",
          pending_students: "Pending students",
          min_students_error: "The number of minimum students is not respected",
          max_students_error: "The number of maximum students is not respected",
          add_ordinary_classes: "Add ordinary classes",
          class_already_added: "Class already added",
          no_study_address_selected: "No study address selected",
          no_study_year_selected: "No study year selected",
          greater_school_year_error:
            "The selected school year must be greater than or equal to the current year",
          no_ordinary_classes_to_add: "No ordinary classes to add",
          ordinary_classes_added: "Classes added successfully",
          existing_ordinary_classes: "Some class already exists",
          wrong_ordinary_classes: "Some class is wrong",
          ordinary_classes_partially_added: "Classes partially added",
          all_classes_already_added: "All classes are already added",
          ordinary_class_not_inserted: "Ordinary classes not inserted",
          ordinary_classes_not_valid: "Ordinary classes not valid",
          add_teachers: "Add teachers",
          teacher_already_added: "Teacher already added",
          empty_name: "Empty name",
          empty_surname: "Empty surname",
          not_valid_email: "Not a valid email",
          no_teachers_to_add: "No teachers to add",
          teachers_added: "Teachers added successfully",
          existing_teachers: "Some teachers already exist",
          wrong_teachers: "Some teacher is wrong",
          teachers_partially_added: "Teachers partially added",
          all_teachers_already_added: "All teachers are already added",
          all_teachers_already_assigned: "All teachers are already assigned",
          teachers_not_inserted: "Teachers not inserted",
          teachers_not_assigned: "Teachers not assigned",
          teachers_not_valid: "Teachers not valid",
          add_students: "Add students",
          students_added: "Students added successfully",
          student_already_added: "Student already added",
          no_students_to_add: "No students to add",
          existing_students: "Some students already exist",
          wrong_students: "Some student is wrong",
          students_partially_added: "Students partially added",
          all_students_already_added: "All students are already added",
          all_students_already_assigned: "All students are already assigned",
          students_not_inserted: "Students not inserted",
          students_not_assigned: "Students not assigned",
          students_not_valid: "Students not valid",
          study_year_address_not_found: "Study year and/or address not found",
          coordinator: "Coordinator",
          teaching_already_added: "Teaching already added",
          student_choice: "Choose a student",
          select_teacher: "Choose a teacher",
          start_date: "Start date",
          end_date: "End date",
          to_confirm: "To confirm",
          new_school_year: "New school year",
          groups: "Gruppi",
          no_learning_sessions: "No learning sessions",
          add_session: "Add session",
          set_valid_school_year: "Set a valid school year",
          cancel_edits_confirm:
            "Are you sure you want to cancel the changes? You will lose all the applied changes",
          cancel_school_year_proposal_confirm:
            "Are you sure you want to cancel? The proposed school year will be deleted",
          learning_sessions_proposal_confirm:
            "Do you confirm the learning sessions of this new school year?",
          learning_sessions_edits_confirm:
            "Do you confirm the changes made to the learning sessions?",
          date_in_past_error: "You cannot set a past date",
          date_in_future_error: "You cannot set a future date",
          anticipate_learning_session_error:
            "You canot anticipate a learning session",
          open_day_too_close:
            "An orientation day must be at least 12 days before the start of the learning session",
          start_after_end: "The start date must be before the end date",
          sessions_not_in_order:
            "The learning sessions are not in chronological order",
          no_changes_detected: "No changes detected",
          at_least_one_group:
            "There must be at least one group per lerning session",
          learning_session_not_found: "Learning session not found",
          learning_session_not_valid: "Learning session not valid",
          learning_session_not_created: "Learning session not created",
          learning_session_not_updated: "Learning session not updated",
          learning_sessions_already_existent:
            "Learning session already existent",
          learning_sessions_added: "Learning sessions added",
          existing_learning_session: "Some learning sessions already exist",
          wrong_learning_session: "Some learning sessions are wrong",
          learning_sessions_partially_added:
            "Learning sessions partially added",
          overlapping_learning_session: "Some learning sessions ovelrap",
          all_overlapping_learning_session:
            "Each learning session overlaps with another",
          start: "Start",
          end: "End",
          profile: "Profile",
          profile_image: "Profile image",
          profile_edits_confirm:
            "Do you confirm the changes made to your profile?",
          image_not_valid: "Image not valid",
          iamge_delete_error: "The image cannot be deleted",
          profile_not_edited: "Profile not edited",
          profile_partial_edited: "Profile partial edited",
          successful_profile_edit: "Profile successfully edited",
          profile_no_edited: "Profile not edited",
          profile_partially_edited: "Profile partially edited",
          empty_field_error: "You cannot entirely delete the text of a field",
        },
      },
      logged_user: false,
      request: {},
      event: {},
      hours_per_credit: 6,
      grades_scale: grades_scale,
      excluded_learning_contexts_id: ["ECA"], // TODO (9): mettere referenza a contesto di apprendimento
      main_learning_context: {
        id: "SPE",
        credits: null,
      }, // TODO (9): mettere referenza a contesto di apprendimento
      courses_per_group: 1,
      year_module: 100,
      static_subscription: true,
      sections_use: false,
      triggers: {
        edit_grades: 0,
        grades: 0,
      },
      default_section: "A", // TODO (6): mettere dove serve
      alert_information: {
        title: "",
        message: "",
        buttons: [],
        inputs: [],
      },
      breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
      },
      button_css: {
        colors: {
          text: {
            name: "white",
            type: "var",
          },
          background: {
            name: "primary",
            type: "var",
          },
        },
        classes: {
          button: {
            radius: true,
          },
        },
      },
    };
  },
});
